import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"หย่าโดยความยินยอม — Uncontested Divorce ไทยและระหว่างประเทศ","metaTitle":"หย่าโดยความยินยอม (หย่าอำเภอ) ไทย + ต่างชาติ | NYC Family Law","metaDesc":"จดทะเบียนหย่าโดยยินยอมที่อำเภอไทย พร้อมข้อตกลงหย่า สินสมรส ค่าเลี้ยงดูบุตร รวมกรณีคู่สมรสต่างชาติ เสร็จภายใน 1 วั — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย"},"en":{"h1":"Uncontested Divorce in Thailand — Mutual-Consent Divorce for Locals & Expats","metaTitle":"Uncontested Divorce Thailand — Amphur Divorce, Assets, Custody | NYC","metaDesc":"Register a mutual-consent divorce at a Thai district office. Full drafting for assets, custody and child — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/family/divorce-uncontested")({
  head: () => {
    const url = `${SEO_SITE}/family/divorce-uncontested`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/family/divorce-uncontested", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/family/divorce-uncontested", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/family/divorce-uncontested", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/family/divorce-uncontested", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/family/divorce-uncontested", "/en/family/divorce-uncontested")],
    };
  },
  component: () => <SubServicePage slug="family/divorce-uncontested" locale="th" />,
});
